module.exports = __webpack_public_path__ + "static/media/OFF-off.5865b1da.svg";